import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import React from 'react';
import HBox from 'components/common/HBox';
import VBox from 'components/common/VBox';

export default function DoubleBarChart(props) {
  const {
    max = 1,
    min = 0,
    values = [],
    recommended,
    unit,
  } = props;

  const bars = React.useMemo(() => {
    return values.map((bar) => {
      let bottom = 0;
      return bar.map(({ label, value }) => {
        const height = (Math.log(Math.max(0, value - min) * 0.05 + 1) + 1) / (Math.log(Math.max(0, max - min) * 0.05 + 1) + 1) * 60 / bar.length + 5;
        const section = {
          label,
          bottom,
          height,
          value,
        };
        bottom += height;
        return section;
      });
    });
  }, [max, min, values]);

  return (
    <div
      {...ex(['Chart', 'DoubleBarChart'], props)}
    >
      {bars.map((bar, barIndex) => {
        let sum = 0;
        return (
          <div key={barIndex} {...ex('Bar')}>
            {bar.map(({ label, height, bottom, value, minor }, valueIndex) => {
              sum += value;
              return (
                <div key={valueIndex} {...ex(['BarSection', label], { style: { bottom: `${bottom}%`, height: `${height}%` } })} >
                  {valueIndex === bar.length - 1 && (
                    <VBox>
                      <HBox>
                        <span>{+sum.toFixed(1)}</span>
                        {0 < barIndex && (
                          <span>{unit}</span>
                        )}
                      </HBox>
                      {0 < barIndex && (
                        <svg width={4} height={49} viewBox="0 0 4 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.83349 3.33333C2.56987 3.33333 3.16683 2.73638 3.16683 2C3.16683 1.26362 2.56987 0.666668 1.83349 0.666668C1.09711 0.666668 0.500161 1.26362 0.500161 2C0.500161 2.73638 1.09711 3.33333 1.83349 3.33333ZM2.0835 49L2.0835 48.5104L1.5835 48.5104L1.5835 49L2.0835 49ZM2.0835 47.5312L2.0835 46.5521L1.5835 46.5521L1.5835 47.5313L2.0835 47.5312ZM2.0835 45.5729L2.0835 44.5937L1.5835 44.5938L1.5835 45.5729L2.0835 45.5729ZM2.0835 43.6146L2.0835 42.6354L1.5835 42.6354L1.5835 43.6146L2.0835 43.6146ZM2.0835 41.6563L2.0835 40.6771L1.5835 40.6771L1.5835 41.6563L2.0835 41.6563ZM2.0835 39.6979L2.0835 38.7187L1.5835 38.7188L1.5835 39.6979L2.0835 39.6979ZM2.0835 37.7396L2.0835 36.7604L1.5835 36.7604L1.5835 37.7396L2.0835 37.7396ZM2.0835 35.7812L2.0835 34.8021L1.5835 34.8021L1.5835 35.7812L2.0835 35.7812ZM2.0835 33.8229L2.0835 32.8437L1.5835 32.8437L1.5835 33.8229L2.0835 33.8229ZM2.0835 31.8646L2.0835 30.8854L1.5835 30.8854L1.5835 31.8646L2.0835 31.8646ZM2.0835 29.9062L2.0835 28.9271L1.5835 28.9271L1.5835 29.9063L2.0835 29.9062ZM2.0835 27.9479L2.0835 26.9688L1.5835 26.9688L1.5835 27.9479L2.0835 27.9479ZM2.0835 25.9896L2.0835 25.0104L1.5835 25.0104L1.5835 25.9896L2.0835 25.9896ZM2.0835 24.0313L2.08349 23.0521L1.58349 23.0521L1.5835 24.0313L2.0835 24.0313ZM2.08349 22.0729L2.08349 21.0938L1.58349 21.0938L1.58349 22.0729L2.08349 22.0729ZM2.08349 20.1146L2.08349 19.1354L1.58349 19.1354L1.58349 20.1146L2.08349 20.1146ZM2.08349 18.1563L2.08349 17.1771L1.58349 17.1771L1.58349 18.1563L2.08349 18.1563ZM2.08349 16.1979L2.08349 15.2188L1.58349 15.2188L1.58349 16.1979L2.08349 16.1979ZM2.08349 14.2396L2.08349 13.2604L1.58349 13.2604L1.58349 14.2396L2.08349 14.2396ZM2.08349 12.2813L2.08349 11.3021L1.58349 11.3021L1.58349 12.2813L2.08349 12.2813ZM2.08349 10.3229L2.08349 9.34375L1.58349 9.34375L1.58349 10.3229L2.08349 10.3229ZM2.08349 8.36458L2.08349 7.38541L1.58349 7.38541L1.58349 8.36458L2.08349 8.36458ZM2.08349 6.40625L2.08349 5.42708L1.58349 5.42708L1.58349 6.40625L2.08349 6.40625ZM2.08349 4.44791L2.08349 3.46874L1.58349 3.46874L1.58349 4.44791L2.08349 4.44791ZM2.08349 2.48957L2.08349 2L1.58349 2L1.58349 2.48957L2.08349 2.48957Z" fill="#667085" />
                        </svg>
                      )}
                    </VBox>
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
      {recommended && (
        <div
          {...ex('Recommended', {
            style: {
              bottom: `${((Math.log(Math.max(0, recommended - min) * 0.05 + 1) + 1) / (Math.log(Math.max(0, max - min) * 0.05 + 1) + 1)) * 60 + 5}%`,
            }
          })}
        >
          <div>
            {recommended}
          </div>
        </div>
      )}
    </div>
  );
}

